












































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import TimesheetStatus from '@/models/Timesheets/TimesheetStatus';

@Component({
    name: 'BookingBookedWorkersEmail'
})
export default class BookingBookedWorkersEmail extends GiganautVueDialog {

  emailAddresses = '';
  copied = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.copied = false;
      this.emailAddresses = '';
      let emails = '';
      for (let index = 0; index < BookingDetailsModule.bookedWorkersVM.timesheets.length; index++) {
        const timesheet = BookingDetailsModule.bookedWorkersVM.timesheets[index];
        if (timesheet.worker.emailAddress !== ''){
          if (timesheet.status != TimesheetStatus.Cancelled) {
            if (emails != '') {
              emails = emails + '; ';
            }
            emails = emails + timesheet.worker.emailAddress;
          }
        }       
      }
      this.emailAddresses = emails;
    }
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.emailAddresses);
      this.copied = true;
    } catch (err) {
      this.copied = false;
    }
  }
}
